import {selector} from 'recoil';

import {
  deviceModelsPageable,
  deviceModelsQueryTrigger,
  deviceModelsState,
  devicesPageable,
  devicesQueryTrigger,
  devicesState,
} from './atoms';

import {DictionaryService} from '../../api/services/dictionary.service';

export const deviceModelsQuery = selector({
  key: 'deviceModelsQuery',
  get: async ({get}) => {
    get(deviceModelsQueryTrigger);
    const pageable = get(deviceModelsPageable);

    const res = await DictionaryService.getAllDeviceModels({
      pageable,
      spec: {
        modelName: '',
      },
    });

    return res.data;
  },
  set: ({set}, newValue) => {
    set(deviceModelsState, newValue);
  },
});

export const devicesQuery = selector({
  key: 'devicesQuery',
  get: async ({get}) => {
    get(devicesQueryTrigger);
    const pageable = get(devicesPageable);

    const res = await DictionaryService.getAllDevices({
      pageable,
    });

    return res.data;
  },
  set: ({set}, newValue) => {
    set(devicesState, newValue);
  },
});
